import { graphql } from '@/shared/graphql/router'

export const INFRINGING_FILE_DETAILS_QUERY = graphql(`
  query InfringingFileDetails($id: ID!) {
    infringement(id: $id) {
      id
      infringingFile {
        id
        name
        type
        copyrightId
        asset {
          __typename
          previewImageUrl
          ... on StreamAsset {
            streamUrl
          }
        }
        metadata {
          sourceLabel
          captureType
          sourceUrl
          recordedAt
          durationSeconds
          owner {
            id
            name
          }
          recognizedOrigins {
            timestamp
            origin {
              id
              name
              flag {
                url
              }
            }
          }
        }
        currentCopyright {
          id
          status
          sourceUrl
          owner {
            id
            name
          }
          recognizedOrigins {
            timestamp
            origin {
              id
              name
              flag {
                url
              }
            }
          }
        }
      }
    }
  }
`)

export const INFRINGING_REGISTRATION_FALLBACK_QUERY = graphql(`
  query InfringingRegistrationFallback($id: ID!) {
    file(id: $id) {
      id
      asset {
        __typename
        previewImageUrl
      }
      analysis {
        __typename
        ... on VideoAnalysis {
          duration
        }
        ... on AudioAnalysis {
          tracks {
            end
          }
        }
      }
    }
  }
`)
